import $ from 'jquery';
import { Directive, ElementRef, OnDestroy, OnInit } from '@angular/core';

@Directive({
  selector: '.ui.dropdown.auto',
})
export class AutoDropdownDirective implements OnInit, OnDestroy {
  public $el;
  private menuElm: HTMLElement;
  private menuElmListener: (e: MouseEvent) => void;

  constructor(elRef: ElementRef) {
    this.$el = $(elRef.nativeElement);
  }

  public ngOnInit() {
    this.$el.dropdown({ action: 'hide' });
    this.menuElm = $(this.$el).find('> .menu').get(0);
    this.menuElmListener = (e: MouseEvent) => {
      const elementToBlur = (document.activeElement as HTMLElement);
      if (elementToBlur) {
        elementToBlur.blur();
      }
      e.stopPropagation();
    };

    this.menuElm.addEventListener('click', this.menuElmListener);
  }

  public ngOnDestroy() {
    this.$el.dropdown('destroy');
    this.menuElm.removeEventListener('click', this.menuElmListener);
  }
}
